<section *ngIf="isVisible && job" class="property-import-progress">
  <div class="property-import-progress__header">
    <div>
      <div class="property-import-progress__title">
        {{ 'PROPERTY_IMPORT.TITLE' | translate }}
      </div>
      <div class="property-import-progress__subtitle">
        {{ job.fileName }}
      </div>
    </div>

    <div class="property-import-progress__actions">
      <nz-tag *ngIf="!isTerminal" nzColor="processing">
        {{ 'PROPERTY_IMPORT.RESUME_ACTIVE' | translate }}
      </nz-tag>
      <nz-tag *ngIf="isSuccess" nzColor="success">
        {{ 'PROPERTY_IMPORT.COMPLETED' | translate }}
      </nz-tag>
      <nz-tag *ngIf="isPartial" nzColor="gold">
        {{ 'PROPERTY_IMPORT.PARTIAL' | translate }}
      </nz-tag>
      <nz-tag *ngIf="isFailure" nzColor="error">
        {{ 'PROPERTY_IMPORT.FAILED' | translate }}
      </nz-tag>
      <button
        *ngIf="dismissible"
        nz-button
        nzType="text"
        class="property-import-progress__dismiss"
        (click)="onDismiss()"
      >
        <span nz-icon nzType="close"></span>
        {{ 'PROPERTY_IMPORT.DISMISS' | translate }}
      </button>
    </div>
  </div>

  <div class="property-import-progress__stage">
    <span nz-icon nzType="sync" [nzSpin]="!isTerminal"></span>
    {{ stageLabelKey | translate }}
  </div>

  <div class="property-import-progress__message" *ngIf="shouldShowProgressMessage">
    {{ progressMessageText }}
  </div>

  <nz-progress
    *ngIf="isProcessingStage; else nonProcessingState"
    [nzPercent]="progressPercent"
    [nzStatus]="isFailure ? 'exception' : (isTerminal ? 'success' : 'active')"
  ></nz-progress>

  <ng-template #nonProcessingState>
    <nz-progress
      *ngIf="isTerminal; else pendingState"
      [nzPercent]="progressPercent"
      [nzStatus]="isFailure ? 'exception' : 'success'"
    ></nz-progress>
  </ng-template>

  <ng-template #pendingState>
    <div class="property-import-progress__pending-bar" aria-hidden="true">
      <span></span>
    </div>
  </ng-template>

  <div class="property-import-progress__stats">
    <div class="property-import-progress__stat">
      <span>{{ 'PROPERTY_IMPORT.STATS.PROCESSED' | translate }}</span>
      <strong>{{ job.processedRows }} / {{ job.totalRows || 0 }}</strong>
    </div>
    <div class="property-import-progress__stat">
      <span>{{ 'PROPERTY_IMPORT.STATS.CREATED' | translate }}</span>
      <strong>{{ job.createdCount }}</strong>
    </div>
    <div class="property-import-progress__stat">
      <span>{{ 'PROPERTY_IMPORT.STATS.UPDATED' | translate }}</span>
      <strong>{{ job.updatedCount }}</strong>
    </div>
    <div class="property-import-progress__stat">
      <span>{{ 'PROPERTY_IMPORT.STATS.SKIPPED' | translate }}</span>
      <strong>{{ job.skippedCount }}</strong>
    </div>
    <div class="property-import-progress__stat">
      <span>{{ 'PROPERTY_IMPORT.STATS.FAILED' | translate }}</span>
      <strong>{{ job.failedCount }}</strong>
    </div>
  </div>

  <nz-alert
    *ngIf="isSuccess"
    nzType="success"
    nzShowIcon
    [nzMessage]="successAlertMessage"
    [nzDescription]="autoDismissCountdownSeconds !== null ? ('PROPERTY_IMPORT.AUTO_DISMISS_HINT' | translate:{ seconds: autoDismissCountdownSeconds }) : null"
  ></nz-alert>

  <nz-alert
    *ngIf="isPartial"
    nzType="warning"
    nzShowIcon
    [nzMessage]="partialAlertMessage"
    [nzDescription]="partialAlertDescription"
  ></nz-alert>

  <nz-alert
    *ngIf="isFailure"
    nzType="error"
    nzShowIcon
    [nzMessage]="failureAlertMessage"
    [nzDescription]="failureAlertDescription"
  ></nz-alert>

  <div class="property-import-progress__errors" *ngIf="errorPreview.length">
    <div class="property-import-progress__errors-header">
      <div class="property-import-progress__errors-title">
        {{ 'PROPERTY_IMPORT.ERRORS_TITLE' | translate }}
      </div>
      <button
        *ngIf="canDownloadErrorReport"
        nz-button
        nzType="link"
        class="property-import-progress__errors-download"
        [disabled]="downloadingErrorReport"
        (click)="downloadErrorReport()"
      >
        <span nz-icon nzType="download"></span>
        {{ 'PROPERTY_IMPORT.DOWNLOAD_ERRORS_REPORT' | translate }}
      </button>
    </div>
    <ul>
      <li *ngFor="let errorMessage of errorPreview">{{ errorMessage }}</li>
    </ul>
  </div>
</section>
